<template>
  <v-data-table :headers="headers"
                :items="debtors"
                class="mt-4"
                hide-default-footer
                :items-per-page="-1"
                :mobile-breakpoint="0" />
</template>

<script>
export default {
  props: ['debtors'],
  computed: {
    headers () {
      return [
        { text: this.$t('name'), value: 'name' }
      ]
    }
  }
}
</script>
